export default {
  id: 0,
  quote_number: '',
  policy_number: '',
  vehicleDetails: {
    cover_type: null,
    vehicle_type: null,
    vehicle_reg: '',
    engine_number: '',
    chassis_number: '',
    vehicle_make: '',
    vehicle_model: '',
    vehicle_color: '',
    year_of_manf: ''
  },
  first_name: '',
  last_name: '',
  email_address: '',
  estimated_value: '',
  start_date: '',
  end_date: '',
  num_of_quarters: '',
  currency: null,
  premium: '0.00',
  base: '0.00',
  levy: '0.00',
  rate: '0',
  discount: '0.00',
  delivery_fee: '0.00',
  total_bill: '0.00'
  
}